export default __webpack_public_path__ + "static/media/TERMINAL_ICON_04.cc987944.svg";